/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AddMyLibraryPeopleRequestViewModel } from "../types/AddMyLibraryPeopleRequestViewModel.ts";

export const addMyLibraryPeopleRequestViewModelSchema = z.object({
  personIds: z
    .array(z.number().int())
    .describe(
      "IDs das pessoas a adicionar. Aceita alunos e professores no mesmo envio. Obrigatório informar ao menos uma pessoa.",
    )
    .nullish(),
}) as unknown as ToZod<AddMyLibraryPeopleRequestViewModel>;
